import script from "./DeviceSetupAlertMixin.vue?vue&type=script&lang=js"
export * from "./DeviceSetupAlertMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__